import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { PERSONAL_OPTIONS } from './constants';
import { PageStyles, TitleStyles } from './PersonalScreen.styles';

export const PersonalScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Personal',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();
  const personal = form.watch('personal');

  const handleChange = (option: OnbOptionType<LayoutDataType['personal']>) => {
    userService.createOrUpdate({
      onboarding_data: {
        personal: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <PageStyles
      bgImage={
        <img
          src={`${S3_BUCKET_URL}/layout-own-ai-pool/personal/background.jpg`}
          alt="AI Character"
        />
      }
      background="dark-solid"
    >
      <IonContent>
        <TitleStyles>
          I actually don't mind when visits get...
          <br />a little more personal
        </TitleStyles>
        <OnboardingOptionsList>
          {PERSONAL_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={personal === option.id}
              control={form.control}
              option={option}
              name="personal"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`personal-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </PageStyles>
  );
};
